
window.addEventListener('options:price', function(e){
  var priceData = e.detail;
  console.log('options price updated', priceData);
  //console.log(discounts);
  if(discounts.discount == 0)
  {
    document.querySelector('.display-price span.discount-text').innerText = "";
    let my_price = (priceData.price / 100).toFixed(2);
    my_price = shop_moneyFormat.replace("(amount)", my_price);
    document.querySelector('.display-price span.price-value').innerText = my_price + ' ' + price_unitText;
  }
  else
  {
    if(discounts.discount_type == 1)
    {
      let txt_discount = '-' + shop_moneyFormat.replace("(amount)", discounts.discount.toFixed(2)) + ' ' + discount_saveText;
      document.querySelector('.display-price span.discount-text').innerText = txt_discount;
      let my_price = (priceData.price / 100) - discounts.discount;
      my_price = my_price.toFixed(2);
      my_price = shop_moneyFormat.replace("(amount)", my_price);
      document.querySelector('.display-price span.price-value').innerText = my_price + ' ' + price_unitText;
    }
    else if(discounts.discount_type == 2)
    {
      let txt_discount = discounts.discount.toString() + '% ' + discount_saveText;
      document.querySelector('.display-price span.discount-text').innerText = txt_discount;
      let my_price = priceData.price / 100;
      let sum_dis;
      sum_dis = ((my_price * discounts.discount) / 100);
      my_price = my_price - sum_dis;
      my_price = my_price.toFixed(2);
      my_price = shop_moneyFormat.replace("(amount)", my_price);
      document.querySelector('.display-price span.price-value').innerText = my_price + ' ' + price_unitText;
    }
  }
});

var chn_evt = 0;
var input_width_min = 0;
var input_width_max = 0;
var input_height_min = 0;
var input_height_max = 0;
var minX = null;
var minY = null;
var maxX = null;
var maxY = null;
var custom_size_lbl = '';
var file_width = 0;
var file_height = 0;
var aspect_ratio = 0;
var inputs_step = 0.5;
var dimensions;
var discounts = {discount: 0,discount_type: 1};

window.addEventListener('option:changed', async function(e) {
  // e.detail contains the option reference
  var option = e.detail;
  
  // print the option to the console
  //console.log('option changed', option);
  
  // check if the option is the one we want
  if(option.name == 'Design Image'){
    let url = option.value;
    if(url != '')
    {
      
      var fileExt = url.split('.').pop();
      
      if(fileExt == 'ai' || fileExt == 'eps' || fileExt == 'pdf' || fileExt == 'psd' || fileExt == 'svg')
      {
        get_file_dimensions(url);
        document.querySelector('product-form').classList.remove('hidden');
        document.querySelector('div.display-price').classList.remove('hidden');
      }
      else
      {
        
        const uploaded_img = new Image();
        uploaded_img.src = url;
        uploaded_img.onload = function() {
          file_width = this.width / 300;
          file_height = this.height / 300;
          aspect_ratio = file_width / file_height;
          
          document.querySelector('product-form').classList.remove('hidden');
          document.querySelector('div.display-price').classList.remove('hidden');

          set_custom_dimensions();
        }
      }
      
    }
    else
    {
      document.querySelector('product-form').classList.add('hidden');
      document.querySelector('div.display-price').classList.add('hidden');
      const customSizeLabel = document.querySelector('[data-option="Custom Size"] div.cl-po--label');
      if (customSizeLabel) customSizeLabel.innerHTML = `<span class="lbl">${ custom_size_lbl }</span>`;
    }
    
  }
  else if (option.name == 'Custom Size') {
    document.querySelector('label[for="custom_dimension_width"]').innerText = option.params.labelX;
    document.querySelector('label[for="custom_dimension_height"]').innerText = option.params.labelY;
    minX = Number(option.params.minX.toFixed(2));
    minY = Number(option.params.minY.toFixed(2));
    maxX = Number(option.params.maxX.toFixed(2));
    maxY = Number(option.params.maxY.toFixed(2));
    custom_size_lbl = option.label;
    
    
  }
  else if (option.name == 'discounts_table') {
    discounts.discount = option._controller.discount;
    discounts.discount_type = option._controller.discountType;
  }
  
});

window.addEventListener('options:rendered', function(e) {
  document.querySelector('product-form').classList.add('hidden');
  document.querySelector('div.display-price').classList.add('hidden');
  // print the option to the console
  //console.log('options rendered', e.detail);
}, { once: true }); // only runs once to get the element reference

function get_file_dimensions(file_url)
{
  let fileExt = file_url.split('.').pop();
  const xhttp = new XMLHttpRequest();
  xhttp.onload = function() {
    
    if(fileExt == 'pdf')
    {
      let loading_task = pdfjsLib.getDocument(file_url);
      loading_task.promise.then(function(pdf)
      {
        pdf.getPage(1).then(function(page) {
          let viewport = page.getViewport({ scale: 1.3333333333333332, });

          let my_canvas = document.createElement('canvas');
          let context = my_canvas.getContext('2d');
          my_canvas.width = viewport.width;
          my_canvas.height = viewport.height;

          var renderContext = {
              canvasContext: context,
              viewport: viewport
          };
          var renderTask = page.render(renderContext);
          renderTask.promise.then(function()
          {
            let wdt = viewport.width;
            let hgt = viewport.height;
            let unt = 'Pixel';
            dimension_converter(wdt,hgt,unt);
            set_custom_dimensions();
              
          });
        });
      });
        
    }
    else if(fileExt == 'ai' || fileExt == 'eps')
    {
      let txt, parser, xmlDoc;
      txt = this.responseText;
      parser = new DOMParser();
      xmlDoc = parser.parseFromString(txt,"text/html");
      let page_width = xmlDoc.getElementsByTagName("stDim:w")[0].childNodes[0].nodeValue;
      let page_height = xmlDoc.getElementsByTagName("stDim:h")[0].childNodes[0].nodeValue;
      let page_unit = xmlDoc.getElementsByTagName("stDim:unit")[0].childNodes[0].nodeValue;
      page_width = Number(page_width);
      page_height = Number(page_height);
      dimension_converter(page_width,page_height,page_unit);
      set_custom_dimensions();
      //console.log("File Width: " + page_width + " File Height: " + page_height + " File Unit: " + page_unit);
    }
    else
    {
      console.error('Invalid file type!');
    }

  }
  xhttp.open("GET", file_url);
  xhttp.send();
}

function dimension_converter(file_w,file_h,file_unit)
{
  if(file_unit == 'Pixel' || file_unit == 'Pixels' || file_unit == 'pixel' || file_unit == 'pixels')
  {
    file_width = file_w * 0.010416666667;
    file_height = file_h * 0.010416666667;
    aspect_ratio = file_width / file_height;
  }
  else if(file_unit == 'Centimeters' || file_unit == 'Centimeter' || file_unit == 'centimeters' || file_unit == 'centimeter')
  {
    file_width = file_w / 2.54;
    file_height = file_h / 2.54;
    aspect_ratio = file_width / file_height;
  }
  else if(file_unit == 'Milimeters' || file_unit == 'Milimeter' || file_unit == 'milimeters' || file_unit == 'milimeter')
  {
    file_width = file_w / 25.4;
    file_height = file_h / 25.4;
    aspect_ratio = file_width / file_height;
  }
  else if(file_unit == 'Inches' || file_unit == 'Inch' || file_unit == 'inches' || file_unit == 'inch')
  {
    file_width = file_w;
    file_height = file_h;
    aspect_ratio = file_width / file_height;
  }
  else
  {
    console.error('File Unit Error: The file unit of measure must be pixels, centimeters or millimeters. Invalid file measure = ' + file_unit );
  }

  //console.log('File Width: ' + file_width + '\n' + 'File Height: ' + file_height + '\n' + 'Aspect Ratio: ' + aspect_ratio);
}

function set_first_dimension_inputs()
{
  let chk = '';
  
  if(file_width > file_height && file_width > maxX)
  {
    chk = 'w > h and w > maxX';
    file_width = maxX;
    file_height = file_width / aspect_ratio;
    
    input_width_max = file_width;
    input_height_max = file_height;
    input_width_min = minY * aspect_ratio;
    input_height_min = minY;
  }
  else if(file_height > file_width && file_height > maxY)
  {
    chk = 'h > w and h > maxY';
    file_height = maxY;
    file_width = file_height * aspect_ratio;
    
    input_width_max = file_width;
    input_height_max = file_height;
    input_width_min = minX;
    input_height_min = minX / aspect_ratio;
  }
  else if(file_width > maxX && file_height > maxY)
  {
    chk = 'w > maxX and h > maxY';
    file_width = maxX;
    file_height = file_width / aspect_ratio;
  }
  else if(file_width < minX && file_height < minY)
  {
    chk = 'w < minX and h < minY';
    file_width = minX;
    file_height = file_width / aspect_ratio;
  }
  else
  {
    chk = 'Dimension values are in appropriate ranges.'
    if(file_width > file_height)
    {
      input_width_max = maxX;
      input_height_max = maxX / aspect_ratio;
      input_width_min = minY * aspect_ratio;
      input_height_min = minY;
    }
    else if(file_width < file_height)
    {
      input_width_max = maxY * aspect_ratio;
      input_height_max = maxY;
      input_width_min = minX;
      input_height_min = minX / aspect_ratio;
    }
    else
    {
      input_width_max = maxX;
      input_height_max = maxY;
      input_width_min = minX;
      input_height_min = minY;
    }
  }
  file_width = Number(file_width.toFixed(2));
  file_height = Number(file_height.toFixed(2));
  document.querySelector('input#custom_dimension_width').value = file_width.toFixed(2);
  document.querySelector('input#custom_dimension_height').value = file_height.toFixed(2);
  document.querySelector('input[name="properties[_Custom Size_x]"]').value = file_width.toFixed(2);
  document.querySelector('input[name="properties[_Custom Size_x]"]').dispatchEvent(new Event('input'));
  document.querySelector('input[name="properties[_Custom Size_y]"]').value = file_height.toFixed(2);
  document.querySelector('input[name="properties[_Custom Size_y]"]').dispatchEvent(new Event('input'));
  //console.log(chk);
  //console.log('File Width: ' + file_width + '\n' + 'File Height: ' + file_height + '\n' + 'Aspect Ratio: ' + aspect_ratio);
}

function set_custom_dimensions()
{
  // Preset-only option configurations do not have Custom Size controls.
  if (!document.querySelector('[data-option="Custom Size"] div.cl-po--label') ||
      !document.querySelector('input#custom_dimension_width') ||
      !document.querySelector('input#custom_dimension_height')) return;
  document.querySelector('[data-option="Custom Size"] div.cl-po--label').innerHTML = `<span class="lbl">${ custom_size_lbl }</span><span class="d_size">Detected size: ${ file_width.toFixed(2) }" x ${ file_height.toFixed(2) }"</span>`;
  
  set_first_dimension_inputs();
}

function input_dimension_width()
{
  let valX = document.querySelector('input#custom_dimension_width').value;
  valX = Number(valX);
  let valY = 0;
  if(valX > input_width_max)
  {
    valX = input_width_max;
  }
  else if(valX < input_width_min)
  {
    valX = input_width_min;
  }
  
  if(file_width > file_height || file_width < file_height)
  {
    valY = valX / aspect_ratio;
  }
  else
  {
    valY = valX;
  }

  if(valY > input_height_max)
  {
    valY = input_height_max;
    valX = valY * aspect_ratio;
  }
  document.querySelector('input#custom_dimension_width').value = valX.toFixed(2);
  document.querySelector('input#custom_dimension_height').value = valY.toFixed(2);
  document.querySelector('input[name="properties[_Custom Size_x]"]').value = valX.toFixed(2);
  document.querySelector('input[name="properties[_Custom Size_x]"]').dispatchEvent(new Event('input'));
  document.querySelector('input[name="properties[_Custom Size_y]"]').value = valY.toFixed(2);
  document.querySelector('input[name="properties[_Custom Size_y]"]').dispatchEvent(new Event('input'));
  //console.log(valX);
  //console.log(valY);
}

function input_dimension_height()
{
  let valY = document.querySelector('input#custom_dimension_height').value;
  valY = Number(valY);
  let valX = 0;
  if(valY > input_height_max)
  {
    valY = input_height_max;
  }
  else if(valY < input_height_min)
  {
    valY = input_height_min;
  }
  
  if(file_width > file_height || file_width < file_height)
  {
    valX = valY * aspect_ratio;
  }
  else
  {
    valX = valY;
  }

  if(valX > input_width_max)
  {
    valX = input_width_max;
    valY = valX / aspect_ratio;
  }
  document.querySelector('input#custom_dimension_width').value = valX.toFixed(2);
  document.querySelector('input#custom_dimension_height').value = valY.toFixed(2);
  document.querySelector('input[name="properties[_Custom Size_x]"]').value = valX.toFixed(2);
  document.querySelector('input[name="properties[_Custom Size_x]"]').dispatchEvent(new Event('input'));
  document.querySelector('input[name="properties[_Custom Size_y]"]').value = valY.toFixed(2);
  document.querySelector('input[name="properties[_Custom Size_y]"]').dispatchEvent(new Event('input'));
}

function width_minus()
{
  let val = document.querySelector('input#custom_dimension_width').value;
  val = Number(val);
  val = val - inputs_step;
  document.querySelector('input#custom_dimension_width').value = val.toFixed(2);
  document.querySelector('input#custom_dimension_width').dispatchEvent(new Event('change'));
}

function width_plus()
{
  let val = document.querySelector('input#custom_dimension_width').value;
  val = Number(val);
  val = val + inputs_step;
  document.querySelector('input#custom_dimension_width').value = val.toFixed(2);
  document.querySelector('input#custom_dimension_width').dispatchEvent(new Event('change'));
}

function height_minus()
{
  let val = document.querySelector('input#custom_dimension_height').value;
  val = Number(val);
  val = val - inputs_step;
  document.querySelector('input#custom_dimension_height').value = val.toFixed(2);
  document.querySelector('input#custom_dimension_height').dispatchEvent(new Event('change'));
}

function height_plus()
{
  let val = document.querySelector('input#custom_dimension_height').value;
  val = Number(val);
  val = val + inputs_step;
  document.querySelector('input#custom_dimension_height').value = val.toFixed(2);
  document.querySelector('input#custom_dimension_height').dispatchEvent(new Event('change'));
}

$(document).on('click','.splide__list .splide__slide',function(e) {
   var index = $(this).find('img').attr('alt');
   var is_popular = $('.cl-po--swatch-item input:checked').val();
   if(is_popular == "Popular Size"){
     $('.cl-po--swatch-item  .cl-po--swatch').each(function(e) {
       var text = $(this).text().trim();
       if(text.indexOf(index) > -1){
           console.log(text,index);  
          $(this).closest('.cl-po--swatch-item').find('input').trigger('click');
       } 
    })
   } 
})